module.exports = __webpack_public_path__ + "img/pr-5.e1b90e0e.png";